import PageWrapper from "../components/shared/PageWrapper"

export const Privacy = () => {
  return (
    <PageWrapper>
      <div className="item-list xl-gap">
        <h1 className="heading-medium">Privacy Policy</h1>
        <p className="italic body spaced">Last Updated March 2, 2026</p>

        <ol className="item-list xl-gap">
          <li>
            <div className="item-list">
              <h2 className="heading-small">Introduction</h2>
              <p className="body spaced">Welcome to chasetheace.cards (“the Website”).</p>
              <p className="body spaced">This Privacy Policy explains what information is collected when you use the Website and how it is used.</p>
              <p className="body spaced">By using the Website, you agree to this Privacy Policy.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Information We Collect</h2>
              <p className="body spaced">We do not require accounts and do not ask for personal information such as your name, email address, or payment details.</p>
              <p className="body spaced">However, certain technical information is automatically collected when you access the Website, including:</p>
              <ul className="decorated">
                <li><p className="body spaced">IP address</p></li>
                <li><p className="body spaced">Browser type and version</p></li>
                <li><p className="body spaced">Device type</p></li>
                <li><p className="body spaced">Basic connection and usage logs</p></li>
              </ul>
              <p className="body spaced">This information is collected automatically by our hosting infrastructure and web server software.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">How We Use Information</h2>
              <p className="body spaced">Technical information may be used to:</p>
              <ul className="decorated">
                <li><p className="body spaced">Operate and maintain the Website</p></li>
                <li><p className="body spaced">Ensure game functionality</p></li>
                <li><p className="body spaced">Monitor performance and stability</p></li>
                <li><p className="body spaced">Prevent abuse, cheating, or malicious activity</p></li>
                <li><p className="body spaced">Diagnose technical issues</p></li>
              </ul>
              <p className="body spaced">We do not sell, rent, or trade your information.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Multiplayer Functionality</h2>
              <p className="body spaced">The Website allows users to create and join multiplayer game rooms using room codes.</p>
              <p className="body spaced">Game state data is transmitted in real time to enable gameplay.</p>
              <p className="body spaced">We do not permanently store player identities.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Data Retention</h2>
              <p className="body spaced">Server logs and technical data may be retained for a limited period for security and operational purposes.</p>
              <p className="body spaced">We do not maintain user accounts or long-term personal profiles.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Third-Party Services</h2>
              <p className="body spaced">The Website is hosted on a private server (VPS).</p>
              <p className="body spaced">We do not currently use advertising networks or third-party tracking services.</p>
              <p className="body spaced">If this changes in the future, this Privacy Policy will be updated accordingly.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">International Users</h2>
              <p className="body spaced">The Website may be accessed from countries outside Canada.</p>
              <p className="body spaced">By using the Website, you understand that data may be processed in the country where the server is located.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Security</h2>
              <p className="body spaced">Reasonable technical measures are used to protect the Website and its infrastructure.</p>
              <p className="body spaced">However, no internet transmission can be guaranteed to be completely secure.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Children's Privacy</h2>
              <p className="body spaced">The Website is a general audience game and does not knowingly collect personal information from children.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Contact</h2>
              <p className="body spaced">If you have questions about this Privacy Policy, you may contact:</p>
              <a href={"mailto:aaron@deroche.design"}>aaron@deroche.design</a>
            </div>
          </li>

        </ol>
      </div>
    </PageWrapper>
  )
}

export const Terms = () => {
  return (
    <PageWrapper>
      <div className="item-list xl-gap">
        <h1 className="heading-medium">Terms of Service</h1>
        <p className="italic body spaced">Last Updated March 2, 2026</p>

        <ol className="item-list xl-gap">
          <li>
            <div className="item-list">
              <h2 className="heading-small">Acceptance of Terms</h2>
              <p className="body spaced">By accessing or using chasetheace.cards (“the Website”), you agree to these Terms of Service.</p>
              <p className="body spaced">If you do not agree, please do not use the Website.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Description of Service</h2>
              <p className="body spaced">The Website provides a free online multiplayer version of the card game “Chase the Ace” (also known as “Screw Your Neighbour”).</p>
              <p className="body spaced">The service is provided “as is” and may be modified, suspended, or discontinued at any time.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Acceptable Use</h2>
              <p className="body spaced">You agree to not:</p>
              <ul className="decorated">
                <li><p className="body spaced">Abuse, harass, or disrupt other players</p></li>
                <li><p className="body spaced">Attempt to exploit bugs or vulnerabilities</p></li>
                <li><p className="body spaced">Reverse engineer or interfere with the Website’s operation</p></li>
                <li><p className="body spaced">Use automated bots or scripts</p></li>
                <li><p className="body spaced">Attempt unauthorized access to servers or game rooms</p></li>
              </ul>
              <p className="body spaced">We reserve the right to restrict or block access for violations.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">No Warranty</h2>
              <p className="body spaced">The Website is provided without warranties of any kind, express or implied.</p>
              <p className="body spaced">We do not guarantee:</p>
              <ul className="decorated">
                <li><p className="body spaced">Continuous availability</p></li>
                <li><p className="body spaced">Error-free gameplay</p></li>
                <li><p className="body spaced">That the service will meet specific expectations</p></li>
              </ul>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Limitation of Liability</h2>
              <p className="body spaced">To the fullest extent permitted by law, the operator of the Website shall not be liable for:</p>
              <ul className="decorated">
                <li><p className="body spaced">Loss of data</p></li>
                <li><p className="body spaced">Loss of profits</p></li>
                <li><p className="body spaced">Service interruptions</p></li>
                <li><p className="body spaced">Any indirect or consequential damages</p></li>
              </ul>
              <p className="body spaced">Use of the Website is at your own risk.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Intellectual Property</h2>
              <p className="body spaced">The Website’s original code, game implementation, and branding are the property of the operator.</p>
              <p className="body spaced">Certain visual, audio, or design assets used on the Website are licensed from third parties and are used in accordance with their respective license terms. Required attributions are provided in the attribution section of the Website.</p>
              <p className="body spaced">The card game “Chase the Ace” is a traditional public card game. This Website is an independent implementation and is not affiliated with any official organization.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Governing Law</h2>
              <p className="body spaced">These Terms shall be governed by the laws of Ontario, Canada, without regard to conflict of law principles.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Changes to Terms</h2>
              <p className="body spaced">These Terms may be updated at any time. Continued use of the Website after changes constitutes acceptance of the revised Terms.</p>
            </div>
          </li>

          <li>
            <div className="item-list">
              <h2 className="heading-small">Contact</h2>
              <p className="body spaced">For questions regarding these Terms:</p>
              <a href={"mailto:aaron@deroche.design"}>aaron@deroche.design</a>
            </div>
          </li>

        </ol>
      </div>
    </PageWrapper>
  )
}